import { useState, useEffect, useCallback } from "react";

// Check if running locally - exported for use in components
export const isLocalhost = () => {
    if (typeof window === 'undefined') return false;
    return window.location.hostname === 'localhost' || 
           window.location.hostname === '127.0.0.1' ||
           window.location.port === '5173';
};

interface QAProfile {
    isQAMode: boolean;
    profile: 'seller' | 'buyer';
    buyerWallet: string;
    toggleQA: () => void;
    switchProfile: () => void;
    currentWallet: string;
}

export function useQAProfile(realWallet: string | undefined): QAProfile {
    const [isQAMode, setIsQAMode] = useState(false);
    const [profile, setProfile] = useState<'seller' | 'buyer'>('seller');

    // Load QA mode from localStorage
    useEffect(() => {
        if (!isLocalhost()) return;
        const saved = localStorage.getItem('jetp2p_qa_mode');
        if (saved === 'true') {
            const savedProfile = localStorage.getItem('jetp2p_qa_profile');
            setIsQAMode(true);
            setProfile((savedProfile as 'seller' | 'buyer') || 'seller');
        }
    }, []);

    const toggleQA = useCallback(() => {
        if (!isLocalhost()) return;
        
        const newMode = !isQAMode;
        setIsQAMode(newMode);
        localStorage.setItem('jetp2p_qa_mode', String(newMode));
        
        if (newMode) {
            setProfile('seller');
            localStorage.setItem('jetp2p_qa_profile', 'seller');
        } else {
            localStorage.setItem('jetp2p_qa_profile', 'seller');
        }
    }, [isQAMode]);

    const switchProfile = useCallback(() => {
        if (!isLocalhost() || !isQAMode) return;
        
        const newProfile = profile === 'seller' ? 'buyer' : 'seller';
        setProfile(newProfile);
        localStorage.setItem('jetp2p_qa_profile', newProfile);
    }, [profile, isQAMode]);

    // In QA mode, always use the real wallet for both seller and buyer
    // This allows testing real transactions with the same wallet
    const currentWallet = realWallet || "";

    return {
        isQAMode: isLocalhost() && isQAMode,
        profile,
        buyerWallet: realWallet || "", // Use real wallet for buyer too
        toggleQA,
        switchProfile,
        currentWallet
    };
}
